type Props = {
  size: number;
};

const IconDownload = ({size}: Props) => {
  return (
    <svg
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        d="M8.67 14.67a8.67 8.67 0 108.66 8.66 8.68 8.68 0 00-8.66-8.66zm3.18 9.75L9.2 27.75a.69.69 0 01-1.04 0l-2.67-3.33A.67.67 0 016 23.33h1.17a.17.17 0 00.16-.16v-3.84a1.33 1.33 0 012.67 0v3.84a.17.17 0 00.17.16h1.16a.67.67 0 01.52 1.09z"
        fill="currentColor"
      />
      <path
        d="M31.22 4L28 .78A2.67 2.67 0 0026.11 0H10.67A2.67 2.67 0 008 2.67v9.7a.33.33 0 00.32.33c.5 0 1.39.05 1.98.11a.33.33 0 00.37-.33V3.33a.67.67 0 01.66-.66h14.5a.67.67 0 01.48.2l2.83 2.82a.67.67 0 01.2.47V24a.67.67 0 01-.67.67h-9.15a.33.33 0 00-.32.28 10.6 10.6 0 01-.48 1.94.33.33 0 00.3.44h10.31A2.67 2.67 0 0032 24.67V5.89A2.67 2.67 0 0031.22 4z"
        fill="currentColor"
      />
      <path
        d="M26 13.33a1 1 0 00-.53-.87l-7.8-4.31a1.18 1.18 0 00-1.11-.02 1 1 0 00-.56.89v6.45a.32.32 0 00.1.23A10.68 10.68 0 0117.9 18a.33.33 0 00.45.14l7.12-3.94a1 1 0 00.53-.88z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconDownload;
